import instance from './interceptor';

export const deliveryBoy = {
  assignDelivery: async (data) => instance.post(`inovice/delivery_boy_assign?remarks=${data.remarks}`, data),
  getAll: async () => instance.get('delivery_boy_assign_page_data/delivery_boy')
};
